const EN_US = {
  'emergingBrandsPortalDomain.title': 'Brand Explorer',
  'emergingBrandsPortalDomain.about.brand': 'About {brand}',
  'emergingBrandsPortalDomain.other.sell.sheet.products': 'Other products in {sellSheet}',
  'emergingBrandsPortalDomain.other.sell.sheets': 'Other sell sheets that includes this item',
  'emergingBrandsPortalDomain.last.week': 'Last week ({startDate} - {endDate})',
  'emergingBrandsPortalDomain.last.month': 'Last 4 weeks ({startDate} - {endDate})',
  'emergingBrandsPortalDomain.last.quarter': 'Last 13 weeks ({startDate} - {endDate})',
  'emergingBrandsPortalDomain.last.half.year': 'Last 26 weeks ({startDate} - {endDate})',
  'emergingBrandsPortalDomain.last.year': 'Last 52 weeks ({startDate} - {endDate})',
  'emergingBrandsPortalDomain.total.sales': 'Sales',
  'emergingBrandsPortalDomain.total.orders': 'Orders',
  'emergingBrandsPortalDomain.total.stores': 'Average stores',
  'emergingBrandsPortalDomain.avg.sales': 'Sales per store',
  'emergingBrandsPortalDomain.avg.orders': 'Orders per store',
  'emergingBrandsPortalDomain.header.stores': 'Stores with sales',
  'emergingBrandsPortalDomain.header.avg.price': 'Avg. price',
  'emergingBrandsPortalDomain.sell.sheet.disclaimer': 'Totals are based on the previous week',
  'emergingBrandsPortalDomain.wow': 'WoW',
  'emergingBrandsPortalDomain.mom': 'MoM',
  'emergingBrandsPortalDomain.qoq': 'QoQ',
  'emergingBrandsPortalDomain.hoh': 'HoH',
  'emergingBrandsPortalDomain.yoy': 'YoY',
} as const

export default EN_US
